import { EdSectionOptions } from '@/content/models/ed-section-options.model';
import { SectionsProvider } from '@/content/providers/sections.provider';
import { ContentType } from '@/content/types/content.types';
import { SECTION_OPTIONS_ROOT_TEMPLATES } from '@/content/values/sections';
import { COURSE_MODE } from '@/courses/enums/course-edition.enum';
import { Section } from '@/courses/models/section.model';
import { SectionProvider } from '@/sections/providers/section.provider';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  name: 'ed-content-sections',
  components: {
    EdContentSidebarSection: () => import(/* EdContentSidebarSection */'@/sections/components/ed-content-sidebar-section/ed-content-sidebar-section.component.vue'),
  }
})
export default class EdContentSectionsComponent extends Vue {
  @Prop({ default: null }) readonly contentId: number;
  @Prop({ default: null }) readonly classId: number;
  @Prop({ default: '' }) readonly componentName: string;
  @Prop({ default: COURSE_MODE.VIEWER }) readonly mode: COURSE_MODE;
  @Prop({ default: 'SUBJECT' }) readonly contentType: ContentType;
  @Prop({ default: () => [] }) readonly sections: Section[];
  @Prop({ default: false }) readonly loading: boolean;
  @Prop({ default: false }) readonly loaded: boolean;
  @Prop({ default: false }) readonly isProject: boolean;
  @Prop({ default: null }) readonly options: EdSectionOptions;

  get isShownWithoutContent(): boolean {
    if (this.mode === COURSE_MODE.VIEWER) {
      return this.contentSections.length > 0;
    }
    return true;
  }

  get contentSections(): Section[] {
    return this.sections.filter(
      cs => cs.fixedSection !== 'FUN' && cs.fixedSection !== 'FILLERS' && cs.fixedSection !== 'ADDITIONAL'
    );
  }

  get lessonCounter() {
    return SectionProvider.getLessonCounter(this.contentSections || []);
  }

  get menuAddOptions() {
    if(this.contentType === 'TEMPLATE') {
      return SectionsProvider.getCreateObjMenu([...SECTION_OPTIONS_ROOT_TEMPLATES], this.$i18n);
    }
    return [];
  }

  goToAddContentSection(minDate: string = null, isCreatingLesson = false) {
    SectionProvider.openLessonCreator(
      this.contentId,
      this.classId,
      null,
      minDate,
      isCreatingLesson
    );
  }

}